import { Business, Organization } from './common.types'

interface InitializedData {
  initialDataLoaded?: boolean
  userId?: number
  auth0Id?: string
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  createdAt?: Date
  roleName?: string | null
  company?: string
  organizations?: Organization[]
  currentOrganization?: Organization
  currentBusiness?: Business
}

type User = Required<Pick<InitializedData, 'firstName' | 'lastName' | 'email' | 'phone'>>
export type CartAuthUser = User & {
  organizations: Organization[]
  onLogout: (options: OnLogoutProps) => Promise<void>
  setUser: StoreStateType['setUser']
  userId: InitializedData['userId']
  auth0Id: InitializedData['auth0Id']
  company: InitializedData['company']
  createdAt: InitializedData['createdAt']
  fullName: string
}

export type StoreStateType = InitializedData & {
  setUser: (user: User) => void

  organizations: Organization[]
  currentOrganization?: Organization
  setOrganization: (organization: Organization, selectedBusiness?: Business) => void

  currentBusiness?: Business
  setBusiness: (organization: Organization, business: Business) => void

  setCurrentContext: (organization, business) => void

  initialDataLoaded: boolean
  fetchInitialData: () => void
  setInitialData: (data: InitializedData) => void

  isLoadingInitialData: boolean
  setIsLoadingInitialData: (isLoading: boolean) => void

  roleName?: string | null
}

export interface OnLogoutProps {
  returnUrl?: string
  skipEndSession?: boolean
  skipClearLocalStorage?: boolean
  skipAuth0Logout?: boolean
  callback?: () => void
}
